import { useFilterValue } from '@btime/react-contexts'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { useFilterValueText } from '../../../utils/helpers/filters'
import FilterLink from '../../../components/filter/FilterLink'
import FilterListItem from '../../../components/list/FilterListItem'
import Link from '../../../packages/kiti/components/actions/Link'
import UsersFilterSideModal from './UsersFilterSideModal'

const UsersFilter = ({ label, field, icon, presentation, ...props }) => {
  const { t } = useTranslation('common')
  const [open, setOpen] = React.useState(false)

  presentation = presentation || 'bar'
  label = label || t('user')
  field = field || 'userIds'
  const value = useFilterValue(field, [])

  const selectedValue = useFilterValueText(field)
  const Link = presentation === 'bar' ? FilterLink : FilterListItem

  return (
    <>
      <Link
        icon={presentation === 'bar' && (icon || 'RiAccountBoxLine')}
        label={label}
        value={selectedValue}
        onClick={() => setOpen(true)}
      />

      <UsersFilterSideModal open={open} onClose={() => setOpen(false)} label={label} field={field} {...props} />
    </>
  )
}

export default UsersFilter
